import { render, staticRenderFns } from "./labelCopy.vue?vue&type=template&id=3ceaf0f4&scoped=true"
import script from "./labelCopy.vue?vue&type=script&lang=js"
export * from "./labelCopy.vue?vue&type=script&lang=js"
import style0 from "./labelCopy.vue?vue&type=style&index=0&id=3ceaf0f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceaf0f4",
  null
  
)

export default component.exports